import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";
import { DROPDOWN_OPTIONS } from "@/constant/global/global.constant";

// storing the state into the selector

const getDevice = function (state: RootState) {
  return state.devices;
}

// Creating the selector and accessing the state

export const getAboutDevice = createSelector(getDevice, (device) => {
  return {
    loading: device?.loading,
    devices: device?.device?.data,
    pagination: device?.device?.pagination,
  };
})

export const getDevicesListDetail = createSelector(getDevice,(reduxStoreData)=>{
     const allDevicesList = reduxStoreData?.devicesList?.data?.map((device)=>({
        id: device?.deviceId,
        name: device?.name,
        sourceId: device?.sourceId,
    }))
     return {allDevicesListData:[DROPDOWN_OPTIONS.ALL_DEVICE_DROPDOWN_OPTION].concat(allDevicesList),pagination:reduxStoreData?.devicesList?.pagination}
});

export const getdevicesListErrorDetails = createSelector(getDevice,(device)=>{
    const devicesListErrorData = {
        error: device?.error,
        message: `Devices : ${device?.message}`
    }
return devicesListErrorData
})